import * as React from 'react'
import classNames from 'classnames'

import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { ExecutionElement } from '../flow/ExecutionElement'
import { ElementLabel } from './ElementLabel'

import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import type { CreateAnswer } from '../../../shared/domain/flows/answer.no-deps'
import type { TimelineDetails } from './TimelineDetails'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'

interface Props {
    deps: CommonDeps
    elementId: Flows.ElementId
    loopPathIds: LoopPathIds
    label: string
    timelineDetails: TimelineDetails
    required: boolean
    choices: Flows.Choice[]
    answerValue: Flows.RadioAnswer['value']
    validationMessages: string[]
    createAnswer: CreateAnswer<Flows.RadioAnswer>
    openOptions?: () => void
}

export class ElementRadio extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    private tryRender = () => {
        const { deps, elementId, label, timelineDetails, required, choices, validationMessages, createAnswer } =
            this.props

        return (
            <ExecutionElement
                deps={deps}
                elementId={elementId}
                loopPathIds={this.props.loopPathIds}
                validationMessages={validationMessages}
                timelineDetails={timelineDetails}
            >
                <ElementLabel
                    required={required}
                    label={label}
                    hasBeenEdited={timelineDetails && timelineDetails.hasBeenEdited}
                    language={deps.language}
                    validationMessages={validationMessages}
                    openOptions={this.props.openOptions}
                />
                <div className="AppCore__flow__ElementRadio">
                    {choices.map((choice) => {
                        const selected = this.props.answerValue === choice.id

                        return (
                            <div
                                key={choice.id}
                                id={`AppCore__flow__ElementRadio__choice-${choice.id}`}
                                className={classNames('AppCore__flow__ElementRadio__choice', {
                                    selected,
                                    'AppCore__flow__ElementRadio__choice--error': validationMessages.length !== 0,
                                })}
                                onClick={() =>
                                    createAnswer((base) => ({
                                        ...base,
                                        type: 'radio',
                                        value: !selected ? choice.id : null,
                                    }))
                                }
                            >
                                <div className="AppCore__flow__ElementRadio__circle" />
                                <div className="AppCore__flow__ElementRadio__label">{choice.label}</div>
                            </div>
                        )
                    })}
                </div>
            </ExecutionElement>
        )
    }
}
